export default __webpack_public_path__ + "static/top-ad539516188b5d947263e175a8264279.jpg";